import { ProductNotifyMeRepository } from '../repositories/ProductNotifyMeRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';

export class ClearNotifyMeFormUseCase {
    private productNotifyMeRepository: ProductNotifyMeRepository;

    constructor() {
        this.productNotifyMeRepository = diContainer.get(serviceNames.productNotifyMeRepository);
    }

    public execute = () => {
        const notifyMeForm = this.productNotifyMeRepository.getNotifyMeForm();
        notifyMeForm.clearStore();
    };
}
